export const getSortedTiles = tiles => {
  let sortedTiles = []

  tiles.sort((a, b) => {
    const weightA = a.attributes && a.attributes.field_weight != null ? a.attributes.field_weight : 0
    const weightB = b.attributes && b.attributes.field_weight != null ? b.attributes.field_weight : 0
    return weightB - weightA
  })

  const threeColumnTiles = tiles.filter(tile => tile.attributes && tile.attributes.field_size === 3)
  const twoColumnTiles = tiles.filter(tile => tile.attributes && tile.attributes.field_size === 2)
  let oneColumnTiles = tiles.filter(tile => tile.attributes && tile.attributes.field_size === 1)

  sortedTiles = sortedTiles.concat(threeColumnTiles)

  for (let i = 0; i < twoColumnTiles.length; i++) {
    if (i % 2 === 0) {
      sortedTiles.push(twoColumnTiles[i])

      if (oneColumnTiles.length > 0) {
        sortedTiles.push(oneColumnTiles.shift())
      }
    } else {
      if (oneColumnTiles.length > 0) {
        sortedTiles.push(oneColumnTiles.shift())
      }

      sortedTiles.push(twoColumnTiles[i])
    }
  }

  sortedTiles = sortedTiles.concat(oneColumnTiles)

  return sortedTiles
}
